import request from '@/libs/request';
import config from '@/config';
import RSA from '@/libs/rsa';
const baseUrl = config.api_base;

/**
 * SSH连接访问
 */
export const DeviceSshConnect = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/ssh/connect`, data);
};

/**
 * SSH断开连接
 */
export const DeviceSshDisconnect = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/ssh/disconnect`, data);
};

/**
 * 查询SSH是否已经创建
 * @param {*} data
 * @returns
 */
export const DeviceSshCreated = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/ssh/status`, data);
};

/**
 * 启动VPN连接
 */
export const DeviceVpnStart = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/vpn/start`, data);
};

/**
 * 重新启动VPN连接
 */
export const DeviceVpnReStart = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/vpn/restart`, data);
};

/**
 * VPN状态查询
 */
export const DeviceVpnStatus = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/vpn/status`, params);
};

/**
 * VPN停止
 */
export const DeviceVpnStop = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/vpn/stop`, params);
};

/**
 * SSH帐密验证
 */
export const DeviceSSHValid = params => {
  // RSA加密传输
  params = { data: RSA.encrypt(JSON.stringify(params || {})) };
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/ssh/valid`, params);
};

/**
 * WEBUI连接访问
 */
export const DeviceWebUIConnect = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/webui/connect`, data);
};

/**
 * WEBUI断开连接
 */
export const DeviceWebUIDisconnect = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/webui/disconnect`, data);
};

/**
 * 查询WEBUI是否已经创建
 * @param {*} data
 * @returns
 */
export const DeviceWebUICreated = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/webui/status`, data);
};

// ---------------------------------

/**
 * 设备的所有状态
 * @param {*} data
 * @returns
 */
export const DevicesStatusAll = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/status/all`, data);
};

/**
 * 查找设备执行状态（多个设备）
 * 其中状态值：0-空闲未执行，1-ftp文件下载中，2-ftp文件上传中，3-执行完成，设备重启中，4-命令执行中。其中0表示设备空闲或者指令已执行完毕回至空闲状态，非0表示命令执行中。
注意:该字段实际起到一个保护锁和状态通知的作用。
 * @param {*} data
 * @returns
 */
export const DevicesStatusCheck = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/status/exec/stats`, data);
};

/**
 * 命令执行，单设备
 */
export const DeviceExecCommand = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/ctrl/exec`, params);
};

/**
 * 命令执行,多设备
 */
export const DeviceExecCommands = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/ctrl/execs`, params);
};

/**
 * 获取多设备命令执行结果
 * @param {*} params
 * @returns
 */
export const DeviceExecCommandsResult = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/ctrl/execs/result`, params);
};

/**
 * 命令执行状态查询{apiNoUse}
 */
export const DeviceExecStatus = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/ctrl/exec/status`, params);
};

/**
 * 参数信息结果
 */
export const DeviceParamsList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/ctrl/param/list`, params);
};

/**
 * 单设备N参数设置
 * @param {*} data
 * @returns
 */
export const DeviceParamsSet = data => {
  return request('POST', '/api/auth/sys/dev/basic/ctrl/param/set', data);
};

/**
 * 获取单设备N参数设置最新数据
 * @param {*} data
 * @returns
 */
export const DeviceParamsSetResult = data => {
  return request('GET', '/api/auth/sys/dev/basic/ctrl/param/set/result', data);
};

/**
 * 多设备单参数设置
 * @param {*} data
 * @returns
 */
export const DeviceParamsSets = data => {
  return request('POST', '/api/auth/sys/dev/basic/ctrl/param/sets', data);
};

/**
 * 获取多设备单参数设置最新数据
 * @param {*} data
 * @returns
 */
export const DeviceParamsSetsResult = data => {
  return request('GET', '/api/auth/sys/dev/basic/ctrl/param/sets/result', data);
};

// 设备管理 ----------------------------------------------------------------

/**
 * 新增设备
 */
export const DeviceAdd = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/add`, data);
};

/**
 * 删除设备
 */
export const DeviceDelete = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/del`, data);
};

/**
 * 设备详情
 */
export const DeviceDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/detail`, params);
};

/**
 * 获取配置列表
 */
export const DeviceConfigList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/ctrl/cfg/list`, params);
};

/**
 * 禁用/启用设备
 */
export const DeviceStatusToggle = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/toggle`, data);
};

/**
 * 批量禁用
 * @param {*} data
 * @returns
 */
export const DeviceDisable = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/disable`, data);
};

/**
 * 编辑设备
 */
export const DeviceEdit = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/edit`, data);
};

/**
 * 设备信息
 */
export const DeviceInfo = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/info`, params);
};

/**
 * 设备分页
 */
export const DeviceList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page`, params);
};

/**
 * 参数导出(没用到，单纯使用前端导出)
 */
export const DeviceExport = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/param/export`, data);
};

/**
 * 参数导入(没用到，前端通过批量设置的接口实现)
 */
export const DeviceImport = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/param/import`, data);
};

/**
 * 获取同站点下的设备
 */
export const DeviceInSameSite = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/same/stations`, data);
};

/**
 * 获取同Model下的设备
 */
export const DeviceInSameModel = data => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/same/models`, data);
};

/**
 *
 * @param {*} params
 * @returns
 */
export const DeviceStatusRefresh = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/status/flash`, params);
};

/**
 * 获取配置Group的列表
 * @param {*} params
 * @returns
 */
export const DeviceConfigGroup = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/dict/group`, params);
};

// --------------------------------

/**
 * 黑名单删除
 */
export const DeviceBlackListDelete = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/blacklist/del`, data);
};

/**
 * 设备黑名单
 */
export const DeviceBlackList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/blacklist/page`, params);
};

/**
 * 设备搜索
 */
export const DeviceSearch = params => {
  return request('GET', `${baseUrl}/api/auth/home/device/query`, params);
};

/**
 * 设备维护
 */
export const DeviceMaintain = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/maintenance`, data);
};

/**
 * 统计设备各个状态的数量
 */
export const DeviceStatusCount = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/tab`, params);
};

/**
 * 设备当前故障
 */
export const DeviceCurrentFault = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/alarm/current`, params);
};

/**
 * 历史故障告警分页
 */
export const DeviceHistoryFault = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/alarm/history`, params);
};

/**
 * 设备操作记录
 */
export const DeviceOperationRecord = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/event/operator`, params);
};

/**
 * 设备控制记录
 */
export const DeviceControlRecord = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/event/ctrl`, params);
};

/**
 * 设备配置记录
 */
export const DeviceParamsRecord = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/event/pc`, params);
};

/**
 * 设备配置项变化
 */
export const DeviceParamsChange = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/page/event/change`, params);
};

/**
 * 设备告警和故障统计
 */
export const DeviceAlarmFaultCount = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/stat/dev/history`, params);
};

/**
 * 设备流量统计接口
 */
export const DeviceTrafficeCount = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/stat/traffic/device`, params);
};

/**
 * 获取当前设备下的所有设备模型控制类型
 */
export const DeviceModelCtrlList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/model/ctrl/all`, params);
};

/**
 * 获取流量平台列表接口
 */
export const DeviceTrafficPlatform = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/stat/traffic/platforms`, params);
};

/**
 * 设备故障排名
 * @param {*} params
 * @returns
 */
export const DeviceFaultRanking = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/basic/stat/dev/rate`, params);
};

/**
 * 批量导入设备
 */
export const DeviceImportBatch = data => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/basic/import/batch`, data);
};
